<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-28 16:33:49
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-30 11:22:09
 * @Description: 
-->
<template>
  <section
    class="hero h-680px relative overflow-hidden lt-sm:w-full lt-sm:h-auto lt-sm:aspect-[750/880]"
  >
    <div class="hero-content landing-container flex items-center pb-48px pt-200px lt-sm:pt-80px">
      <div class="hero-text text-left w-full lt-sm:text-center">
        <h1 class="hero-title font-s-48px font-semibold text-#000000 lt-sm:font-s-56px">
          智慧社区整体解决方案
        </h1>
        <p
          class="hero-subtitle font-s-18px text-main/70 lt-sm:mt-12px lt-sm:font-s-26px lt-sm:px-25px lt-xs:px-0"
        >
          绘家科技助力物业管理数字化转型，提升服务品质与业主满意度。
        </p>

        <ul
          class="hero-metrics mt-35px flex items-center gap-48px lt-sm:justify-center lt-sm:mt-20px lt-sm:gap-76px"
        >
          <li
            v-for="(item, index) in metrics"
            :key="index"
            class="metric flex items-start flex-col lt-sm:items-center"
          >
            <strong
              class="d-din-pro-600-semibold metric-value font-s-32px font-semibold text-primary lt-sm:font-s-52px"
            >
              {{ item.value }}
            </strong>
            <span class="metric-label font-s-14px text-#384146 lt-sm:font-s-24px">
              {{ item.label }}
            </span>
          </li>
        </ul>
        <div
          class="hero-actions mt-35px flex items-center gap-16px lt-sm:justify-center lt-sm:absolute lt-sm:bottom-80px lt-sm:left-1/2 lt-sm:-translate-x-1/2"
        >
          <button
            class="btn-primary hero-btn-primary w-127px h-56px rounded-8px text-white font-s-18px pf-sc-semibold lt-sm:w-238px lt-sm:h-83px lt-sm:font-s-28px lt-sm:rounded-8px"
            @click="openConsultation"
          >
            立即咨询
          </button>
          <!--
          <button
            class="hero-btn-outline w-127px h-56px bg-white border-primary border-1 rounded-8px hover:opacity-80 font-s-18px font-semibold text-primary lt-sm:w-168px lt-sm:h-71px lt-sm:font-s-24px lt-sm:rounded-8px"
            @click="openConsultation"
          >
            免费咨询
          </button>
          -->
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { openConsultation } = useConsultation()

  const metrics = [
    { value: '300+', label: '服务客户' },
    { value: '800+', label: '管理小区' },
    { value: '50w+', label: '管理房屋' },
  ]
</script>

<style scoped lang="scss">
  .hero {
    background-size: cover;
    background-position: center;
    background-image: url('@/assets/images/banner.jpg');

    @screen lt-sm {
      aspect-ratio: 750/880;
      background-image: url('@/assets/images/banner-mobile.jpg');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .btn-primary {
    @apply bg-gradient-to-r from-[#779EFF] to-[#0A50FF];
    border: none;
    outline: none;
    &:hover {
      opacity: 0.8;
    }
  }
</style>
